"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageGalleryComponent = exports.ImageGalleryComponent = void 0;
const app_1 = require("app");
const swiper_1 = require("swiper");
const index_1 = require("Views/Partials/Components/KeepTheRhythm/index");
const PreviewBox_1 = require("../PreviewBox/PreviewBox");
const app_2 = require("app");
class ImageGalleryComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.swiper-slider';
        this.pageLoad = false;
        this.activeSlidButton = null;
        this.onSlideChange = (currentElement) => {
            if (currentElement) {
                const activeSlide = currentElement.find('.swiper-slide-active');
                const activeSlideButton = activeSlide.find('.cta-primary');
                activeSlideButton.attr('tabindex', 0);
                if (this.activeSlidButton) {
                    this.activeSlidButton.attr('tabindex', -1);
                }
                this.activeSlidButton = activeSlideButton;
            }
        };
    }
    OnInit() {
        this.el.forEach(elem => {
            this.initGallery(elem);
        });
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        const onLoad = () => {
            this.el.forEach(el => el.classList.add(that.selector.substring(1) + '--inited'));
        };
        // if ie onload doesn't work
        const timeout = setTimeout(() => {
            if (!this.pageLoad) {
                this.pageLoad = true;
                onLoad();
            }
        }, 1000);
        const elWithPlayButton = [];
        this.el.forEach(el => el
            .querySelectorAll('.gallery-top .swiper-slide .play-video-button')
            .forEach(item => elWithPlayButton.push(item)));
        elWithPlayButton.forEach(item => {
            item.addEventListener('click', function (event) {
                (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, this, item.hasAttribute('href'));
            });
            item.addEventListener('keypress', function (event) {
                if (event.key === app_1.keyNameMapping.enter || event.key === app_1.keyNameMapping.space) {
                    (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, this, item.hasAttribute('href'));
                }
            });
        });
        app_1.ComponentService.UpdateComponentsSelector();
        window.addEventListener('load', () => {
            if (!this.pageLoad) {
                this.pageLoad = true;
                clearTimeout(timeout);
                onLoad();
            }
        }, true);
    }
    initGallery(elem) {
        const $elem = $(elem);
        const galleryTopElem = $elem.find('.gallery-top')[0];
        const mouseoverEvent = (0, app_2.createCustomEvent)('mouseover');
        const mouseleaveEvent = (0, app_2.createCustomEvent)('mouseleave');
        let swiper;
        if ($(galleryTopElem).find('.swiper-slide').length < 2) {
            return;
        }
        const galleryTop = galleryTopElem.swiper;
        if (!galleryTop) {
            try {
                swiper = new swiper_1.default(galleryTopElem, {
                    loop: true,
                    navigation: {
                        nextEl: '.swiper-button-next-webex',
                        prevEl: '.swiper-button-prev-webex',
                    },
                    pagination: {
                        clickable: true,
                        el: '.swiper-pagination',
                        bulletActiveClass: 'bg-icon-primary border-0',
                        bulletClass: 'border-primary h-2.5 w-2.5 rounded-full border',
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    runCallbacksOnInit: false,
                    spaceBetween: 20,
                    a11y: {
                        enabled: true,
                    },
                    on: {
                        slideChangeTransitionEnd: () => this.onSlideChange($elem),
                    },
                    observer: true,
                    observeParents: true,
                });
            }
            catch (e) {
                console.error(e);
            }
            const activeSlideButton = $(this.el).find('.swiper-slide-active .cta-primary');
            activeSlideButton.attr('tabindex', 0);
            this.activeSlidButton = activeSlideButton;
            // MouseOver event handler
            galleryTopElem.dispatchEvent(mouseoverEvent);
            galleryTopElem.dispatchEvent(mouseleaveEvent);
            galleryTopElem.addEventListener('mouseover', function () {
                swiper.autoplay.stop();
            });
            galleryTopElem.addEventListener('mouseleave', function () {
                swiper.autoplay.start();
            });
        }
        index_1.KTR.SetPendingUpdate();
    }
}
exports.ImageGalleryComponent = ImageGalleryComponent;
exports.imageGalleryComponent = new ImageGalleryComponent();
